import { GridTable } from '~/components/GridTable';
import { parseCarriage } from '~/utils/equipment';

import { getRowStats, getShoeId } from '../utils';

const columnLabels = ['', 'STARTER', 'PLACERING', 'SEGER-%', 'ROI'];

const Horse = ({ stats, start, betType }) => {
  const shoeId = getShoeId(start);
  const carriage = parseCarriage(start);

  return (
    <GridTable
      labels={columnLabels}
      alignColumnTitlesRight
      gridTemplateColumns="3fr repeat(4, max-content)"
      data={[
        getRowStats(stats.all, 'Alla starter'),
        getRowStats(stats.track, 'Akutell bana'),
        getRowStats(stats.season, 'Årstid'),
        // Show only V75 stats
        ...(betType === 'V75' ? [getRowStats(stats[betType], betType)] : []),
        getRowStats(stats.frontrunner, 'Spets'),
        ...(shoeId
          ? [getRowStats(stats[`shoes_${shoeId}`], 'Aktuell balans')]
          : []),
        ...(start.preliminary_equipment &&
        start.preliminary_equipment.carriage_id
          ? [
              getRowStats(
                stats[`carriage_${start.preliminary_equipment.carriage_id}`],
                'Aktuell vagn',
              ),
            ]
          : []),
        ...(carriage
          ? [
              getRowStats(
                stats[`carriage_${carriage.carriageShort === 'VA' ? 10 : 20}`],
                'Aktuell vagn',
              ),
            ]
          : []),
      ]}
    />
  );
};

export default Horse;
